import { render, staticRenderFns } from "./SettingLayout.vue?vue&type=template&id=5b1fc8dc&scoped=true"
import script from "./SettingLayout.vue?vue&type=script&lang=js"
export * from "./SettingLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingLayout.vue?vue&type=style&index=0&id=5b1fc8dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fc8dc",
  null
  
)

export default component.exports